import { Grid } from "@material-ui/core";
import moment from "moment";
import { FunctionComponent, useMemo } from "react";
import { Option } from "space-monad";
import styled from "styled-components";
import { KycIcon } from "../../../components/icons/status";
import { Widget } from "../../../components/widget";
import { validationFields } from "../../../store/common/models/fields";
import { VerificationDTO } from "../../../store/verification/models/dto/aml";

const StyledWidget = styled(Widget)`
  &:not(:last-child) {
    margin-bottom: 1em;
  }
`;

const KycStatus = styled.div`
  margin-right: 1em;
`;

const Label = styled.span`
  font-weight: 500;
`;

export const SingleBusinessAml: FunctionComponent<{
  fraudCheckId: string;
  item: VerificationDTO.Responses.GetSingleBusinessAml.T;
}> = ({ item }) => {
  const {
    companyName,
    createdDate,
    declineCodes,
    filters,
    incorporationDate,
    status,
  } = item;

  const formattedDate = useMemo(
    () => moment.utc(createdDate).local().format("yyy-MM-DD HH:mm"),
    [createdDate]
  );

  const companyNameName = validationFields.companyName.useName();
  const companyIncorporationDateName = validationFields.companyIncorporationDate.useName();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <StyledWidget title="Overview">
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Label>{companyNameName}:</Label>
                  </Grid>
                  <Grid item xs={6}>
                    {companyName}
                  </Grid>
                  <Grid item xs={6}>
                    <Label>{companyIncorporationDateName}:</Label>
                  </Grid>
                  <Grid item xs={6}>
                    {Option(incorporationDate)
                      .map((d) => moment.utc(d).local().format("DD-MM-yyyy"))
                      .get() ?? "n/a"}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Label>Status:</Label>
                  </Grid>
                  <Grid item xs={6}>
                    <KycStatus>{KycIcon(status, "aml")}</KycStatus>
                  </Grid>
                  <Grid item xs={6}>
                    <Label>Date Submitted:</Label>
                  </Grid>
                  <Grid item xs={6}>
                    <KycStatus>{formattedDate}</KycStatus>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </StyledWidget>
        </Grid>
        {Option(declineCodes)
          .filter((codes) => codes.length > 0)
          .map((codes) => (
            <Grid item xs={12} lg={6}>
              <StyledWidget title="Decline Reasons">
                {codes.map((x, i) => (
                  <p key={i}>{x.message}</p>
                ))}
              </StyledWidget>
            </Grid>
          ))
          .get() || null}
        {Option(filters)
          .filter((filters) => filters.length > 0)
          .map((filter) => (
            <Grid item xs={12} lg={6}>
              <StyledWidget title="Filters">
                {filter.map((x, i) => (
                  <p key={i}>{x}</p>
                ))}
              </StyledWidget>
            </Grid>
          ))
          .get() || null}
      </Grid>
    </>
  );
};
